import { FonteService } from "../../../services/FonteService";
import Breadcrumb from "../../../components/breadcrumbs/Breadcrumb.vue";
import FonteForm from "../../../components/forms/FonteForm.vue";

export default {
    name: "EditarFonte",
    props: {
        activeModal: {
            default: false,
            type: Boolean,
        }
    },
    components: {
        Breadcrumb,
        FonteForm,
    },
    data: () => ({
        breadcrumbs: [
            {
                text: 'Página Inicial',
                disabled: false,
                href: '/',
            },
            {
                text: 'Configuração',
                disabled: false,
                href: '/gerenciar-fontes',
            },
            {
                text: 'Editar Fonte',
                disabled: true
            }
        ],
        fonteData: {},
        loading: false,
    }),
    created() {
        this.carregarFonte(this.$route.params.id);
    },
    methods: {
        async handleSave(formData) {
            try {
                this.loading = true;
                
                // Converter dados do formulário para FormData
                const postData = new FormData();
                postData.append("exercicio", formData.exercicio);
                postData.append("codigo_fonte", formData.codigoFonte);
                postData.append("descricao", formData.descricao);
                postData.append("ativo", formData.ativo ? 1 : 0);

                // Atualizar a fonte
                const response = await FonteService.update(this.$route.params.id, postData);
                
                if (response) {
                    // Redirecionar para a listagem
                    this.$router.push('/gerenciar-fontes');
                } else {
                    throw new Error('Erro ao atualizar fonte');
                }
            } catch (error) {
                console.error('Erro ao atualizar fonte:', error);
                throw error;
            } finally {
                this.loading = false;
            }
        },
        
        handleCancel() {
            this.$router.push('/gerenciar-fontes');
        },
        
        async carregarFonte(id) {
            try {
                const response = await FonteService.show(id);

                if (response) {
                    const data = response.data;
                    // Passa os dados crus para o FonteForm via prop initialData
                    this.fonteData = data;
                } else {
                    console.error('Não foi possível carregar os dados da fonte.');
                }
            } catch (error) {
                console.error('Ocorreu um erro ao carregar os dados da fonte:', error);
            }
        }
    }
};
